import { Box, Container } from "@mui/material";
import { GlobalHeader } from "@WahooFitness/wahoo-offline-mfe";
import { useMemo } from "react";
import { getEducationVideos, getEmbedUrl, EducationVideoId } from "./educationVideos";

function EducationVideoPlayer({ videoId }: { videoId: EducationVideoId }) {
  const video = useMemo(() => getEducationVideos()[videoId], [videoId]);

  return (
    <Container maxWidth="sm" disableGutters sx={{ minHeight: "100%" }}>
      <GlobalHeader title={video.title} />
      <Box sx={{ aspectRatio: "16 / 9", width: "100%", backgroundColor: "common.black" }}>
        <iframe
          src={getEmbedUrl(video.youtubeId)}
          title={video.title}
          width="100%"
          height="100%"
          style={{ border: 0, display: "block" }}
          allow="autoplay; encrypted-media; picture-in-picture; fullscreen"
          allowFullScreen
          data-testid="education-video-player"
        />
      </Box>
    </Container>
  );
}

export default EducationVideoPlayer;
